import { UserState, UserActionTypes, CREATE_USER, USER_DETAILS ,UserDetailsTypes} from "./types";

const initialState: UserState = {
  data: {
    user:{}
  },
  userDetails: {}
}


export function userReducer(
  state = initialState,
  action: UserActionTypes | UserDetailsTypes
): UserState {
  switch (action.type) {
    case CREATE_USER:
      return {
        ...state, data: {
          ...action.data
        }
      }
    case USER_DETAILS:
      return {
        ...state, userDetails: {
          ...action.data
        }
      }
    default:
      return state
  }
}